import Divider from '@/atoms/Divider';

const NewDivider = () => <Divider />;

export default NewDivider;
